import ProductCardLoading from './ProductCardLoading';

export default ProductCardLoading;
